function HeadphonesIcon({ size = 26 }) {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M3 18v-6a9 9 0 0 1 18 0v6" />
            <path d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z" />
        </svg>
    );
}

function LockIcon({ size = 16 }) {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
            <path d="M7 11V7a5 5 0 0 1 10 0v4" />
        </svg>
    );
}

function SoundWaveGraphic() {
    return (
        <div className="listening-soundwave-bars" aria-hidden="true">
            <span className="soundwave-bar soundwave-bar--1" />
            <span className="soundwave-bar soundwave-bar--2" />
            <span className="soundwave-bar soundwave-bar--3" />
            <span className="soundwave-bar soundwave-bar--4" />
        </div>
    );
}

function ListeningUnitCard({
    unitNumber,
    title,
    wordCount = 0,
    practicedCount = 0,
    familiarity = 0,
    locked = false,
    onStart
}) {
    const familiarityPercent = Math.round(familiarity * 100);
    const hasPracticed = practicedCount > 0;

    return (
        <article className={`listening-unit-card${locked ? " listening-unit-card--locked" : ""}`}>
            <div className="listening-unit-card__visual">
                <div className="listening-unit-card__icon-wrap">
                    <HeadphonesIcon size={26} />
                </div>
            </div>

            <div className="listening-unit-card__content">
                <div className="listening-unit-card__top">
                    <span className="listening-unit-card__badge">
                        Unit {unitNumber} Audio Challenge
                    </span>
                    <SoundWaveGraphic />
                    {locked && (
                        <span className="listening-unit-card__lock-badge">
                            <LockIcon size={13} /> Locked
                        </span>
                    )}
                </div>

                <h4 className="listening-unit-card__title">
                    {title || `Unit ${unitNumber} Vocabulary`}
                </h4>

                <div className="listening-unit-card__meta">
                    <span className="listening-meta-pill">
                        {wordCount} {wordCount === 1 ? "word" : "words"} in unit
                    </span>
                    <span className="listening-meta-pill">
                        {practicedCount} practiced by ear
                    </span>
                    <span className="listening-meta-pill listening-meta-pill--accent">
                        {familiarityPercent}% accuracy
                    </span>
                </div>

                <div className="listening-unit-card__progress-wrap">
                    <div className="listening-progress-bar">
                        <div
                            className="listening-progress-bar__fill"
                            style={{ width: `${familiarityPercent}%` }}
                        />
                    </div>
                </div>
            </div>

            <div className="listening-unit-card__action">
                {locked ? (
                    <button
                        type="button"
                        className="listening-unit-card__btn listening-unit-card__btn--disabled"
                        disabled
                    >
                        <LockIcon size={14} /> Locked
                    </button>
                ) : (
                    <button
                        type="button"
                        className="listening-unit-card__btn"
                        onClick={onStart}
                    >
                        {hasPracticed ? "Listen Again" : "Start Listening"}
                    </button>
                )}
            </div>
        </article>
    );
}

export default ListeningUnitCard;
